/**
 * The look of the panel's failed-turn box and the footnote under it — ONE
 * definition (outlook-orachat-uplift s5 r2 CR-6). `OraChatV2Panel` draws its
 * default box with these, and a host that renders its own failed-turn notice
 * (the Outlook add-in's Assistant) uses the same, so the two never drift.
 * Light on purpose: importing this never pulls in the panel.
 */
import type { CSSProperties } from "react";

/** The error box: radius, border, colours and type. Margins are the caller's. */
export const TURN_ERROR_BOX_STYLE: CSSProperties = {
  padding: "8px 12px",
  borderRadius: 8,
  background: "#FEF3F2",
  border: "1px solid #FDA29B",
  color: "#7A271A",
  fontSize: 12.5,
};

/** The footnote under the box (e.g. what still works in the host). */
export const TURN_ERROR_FOOTNOTE_STYLE: CSSProperties = {
  marginTop: 6,
  padding: "0 2px",
  fontSize: 12,
  color: "#475467",
};
